/** @jsx jsx */
import { jsx } from '@compiled/react';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';

import Tooltip from '@atlaskit/tooltip';
import { Inline } from '@atlaskit/primitives/compiled';
import { useCommentContext } from './CommentContextProvider.tsx';
import { useRestrictedToText } from './utils.tsx';

const CommentRestrictedToIndicator = () => {
	const { isDeleted, isSaving, isEditing, isOptimistic } = useCommentContext();
	const restrictedToText = useRestrictedToText();
	const hasRestrictedToText = restrictedToText.length > 0;

	if (!hasRestrictedToText || isDeleted) {
		return null;
	}
	if (!isOptimistic && (isSaving || !hasRestrictedToText || isEditing)) {
		return null;
	}

	return (
		<Inline
			alignBlock="center"
			space="space.050"
			as="span"
			testId="issue-comment-base.ui.comment.custom-comment.restricted-to"
		>
			<Tooltip content={restrictedToText}>
				<LockLockedIcon color="currentColor" label="" LEGACY_size="small" size="small" />
			</Tooltip>
		</Inline>
	);
};
export default CommentRestrictedToIndicator;
